/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_Q2Inputs */

const en_guide_what_is_json_faq_q2 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can JSON contain comments?`)
};

const ko_guide_what_is_json_faq_q2 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에 주석을 넣을 수 있나요?`)
};

const ja_guide_what_is_json_faq_q2 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONにコメントを含めることはできますか？`)
};

/**
* | output |
* | --- |
* | "Can JSON contain comments?" |
*
* @param {Guide_What_Is_Json_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_q2 = /** @type {((inputs?: Guide_What_Is_Json_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_q2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_q2(inputs)
	return ja_guide_what_is_json_faq_q2(inputs)
});